"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var PanelContext = _interopRequireWildcard(require("../context/PanelContext"));

var _EventHandlers = require("../core/EventHandlers");

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _Styles = require("../utils/Styles");

var _PanelTransition = _interopRequireDefault(require("./internal/PanelTransition"));

var _panelUtils = require("./internal/panelUtils");

var _DropdownContext = require("../context/DropdownContext");

var inPanelContext = {
  inPanel: true
};

var getStyle = function getStyle(style, computedWidth) {
  return Object.assign({}, style, {
    width: computedWidth
  });
};

var getClassName = function getClassName(align, className, sandboxed) {
  return (0, _classnames.default)(className, 'private-panel', {
    'private-panel--left': align === 'left',
    'private-panel--right': align === 'right',
    'private-panel--sandboxed': sandboxed
  });
};

var getPanelClassName = function getPanelClassName(panelClassName, bodyCount, headerCount) {
  return (0, _classnames.default)(panelClassName, 'private-panel__container', {
    'private-panel__container--with-body': bodyCount > 0,
    'private-panel__container--with-header': headerCount > 0
  });
};

var UIPanel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIPanel, _React$Component);

  function UIPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIPanel).call(this, props));

    _this.handleWheel = function (evt) {
      // Allow a custom wheel handler to override this one
      var _this$props = _this.props,
          onWheel = _this$props.onWheel,
          scrollElementRef = _this$props.scrollElementRef;

      if (typeof onWheel === 'function') {
        onWheel(evt);
        return;
      }

      (0, _EventHandlers.constrainVerticalWheelEvent)(evt, scrollElementRef.current);
    };

    _this.state = {
      bodyCount: 0,
      headerCount: 0
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._getTransitionProps = (0, _memoizeOne.default)(_panelUtils.getPanelTransitionProps);
    _this._isMounted = true; // Not technically, but child context funcs are called before didMount.

    _this._hasHeader = false;
    _this._hasBody = false; // Track the number of UIPanelHeader and UIPanelBody instances this panel contains. This code
    // should be removed once all headerless/bodyless panels are eliminated.

    _this._panelComponentRegistrationContextValue = {
      registerPanelBody: function registerPanelBody() {
        _this._hasBody = true;

        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              bodyCount: state.bodyCount + 1
            };
          });
        }
      },
      unregisterPanelBody: function unregisterPanelBody() {
        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              bodyCount: state.bodyCount - 1
            };
          });
        }
      },
      registerPanelHeader: function registerPanelHeader() {
        _this._hasHeader = true;

        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              headerCount: state.headerCount + 1
            };
          });
        }
      },
      unregisterPanelHeader: function unregisterPanelHeader() {
        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              headerCount: state.headerCount - 1
            };
          });
        }
      }
    };
    return _this;
  }

  (0, _createClass2.default)(UIPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElementRef = this.props.scrollElementRef; // Using the React `onWheel` event would be restrictive in Chrome (#6272)

      scrollElementRef.current.addEventListener('wheel', this.handleWheel);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          animate = _this$props2.animate,
          children = _this$props2.children,
          className = _this$props2.className,
          onOpenStart = _this$props2.onOpenStart,
          onOpenComplete = _this$props2.onOpenComplete,
          onCloseStart = _this$props2.onCloseStart,
          onCloseComplete = _this$props2.onCloseComplete,
          __onWheel = _this$props2.onWheel,
          panelClassName = _this$props2.panelClassName,
          __panelKey = _this$props2.panelKey,
          rootNode = _this$props2.rootNode,
          scrollElementRef = _this$props2.scrollElementRef,
          style = _this$props2.style,
          width = _this$props2.width,
          _dontMakeNewLayer = _this$props2._dontMakeNewLayer,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["align", "animate", "children", "className", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "onWheel", "panelClassName", "panelKey", "rootNode", "scrollElementRef", "style", "width", "_dontMakeNewLayer"]);
      var _this$state = this.state,
          bodyCount = _this$state.bodyCount,
          headerCount = _this$state.headerCount;
      var sandboxed = this.context.sandboxed;
      var computedWidth = (style || {}).width || width;
      computedWidth = (0, _Styles.percentToVW)(computedWidth);

      var renderedPanel = _react.default.createElement(PanelContext.Provider, {
        value: inPanelContext
      }, _react.default.createElement("div", Object.assign({}, rest, {
        className: getClassName(align, className, sandboxed),
        ref: scrollElementRef,
        style: this._getStyle(style, computedWidth)
      }), _react.default.createElement(_PanelComponentRegistrationContext.Provider, {
        value: this._panelComponentRegistrationContextValue
      }, _react.default.createElement("div", {
        className: getPanelClassName(panelClassName, bodyCount, headerCount)
      }, children), _react.default.createElement(_DropdownContext.DropdownContextComponent, {
        componentName: UIPanel.displayName
      }))));

      if (_dontMakeNewLayer || sandboxed) {
        return renderedPanel;
      }

      return _react.default.createElement(_UILayer.default, {
        "data-layer-for": "UIPanel",
        rootNode: rootNode,
        Transition: _PanelTransition.default,
        transitionProps: this._getTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate)
      }, renderedPanel);
    }
  }]);
  return UIPanel;
}(_react.default.Component);

UIPanel.propTypes = {
  animate: _propTypes.default.bool.isRequired,
  align: _propTypes.default.oneOf(['left', 'right']).isRequired,
  children: _propTypes.default.node,
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  panelClassName: _propTypes.default.string,
  rootNode: _UILayer.default.propTypes.rootNode,
  scrollElementRef: _refObject.default.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  _dontMakeNewLayer: _propTypes.default.bool,
  panelKey: _propTypes.default.string
};
UIPanel.contextTypes = {
  sandboxed: _propTypes.default.bool
};
UIPanel.defaultProps = {
  align: 'right',
  animate: true,
  width: '30%',
  _dontMakeNewLayer: false
};
UIPanel.displayName = 'UIPanel';

var _default = (0, _ShareScrollElement.default)(UIPanel);

exports.default = _default;
module.exports = exports.default;